import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';

@Injectable({
    providedIn: 'root',
})
export class YoutubeApiLoadingService {
    apiLoaded = false;
    constructor(
        private environmentService: EnvironmentService,
        @Inject(DOCUMENT) private document: Document
    ) {}

    loadApi() {
        if (this.environmentService.isBrowser() && !this.apiLoaded) {
            // This code loads the IFrame Player API code asynchronously, according to the instructions at
            // https://developers.google.com/youtube/iframe_api_reference#Getting_Started
            const tag = this.document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            this.document.body.appendChild(tag);
            this.apiLoaded = true;
        }
    }
}
